import { createFileRoute, Navigate } from "@tanstack/react-router";
import { AppLayout } from "@/components/layouts/AppLayout";
import { DevtoolsPage } from "@/components/pages/DevtoolsPage";
import { trpc } from "@/lib/trpc";

export const Route = createFileRoute("/devtools")({
  component: Devtools,
});

function Devtools() {
  const { data: user, isLoading } = trpc.user.me.useQuery();

  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <div className="text-muted-foreground">Cargando...</div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Only show devtools in dev mode
  if (!import.meta.env.DEV) {
    return <Navigate to="/" />;
  }

  return (
    <AppLayout>
      <DevtoolsPage />
    </AppLayout>
  );
}
